import axios from "../../libs/httpClient";
import * as userAuth from "./userAuth";
import * as ldap from "./ldap";
import * as sessionTable from "./sessionTable";

axios.defaults.withCredentials = true;

// Единая точка доступа к backend API 
export default class BackendConnector {
    static replacer = userAuth.replacer;
    static getCurrentUser = userAuth.getCurrentUser;
    static login = userAuth.login;
    static logout = userAuth.logout;

    static ldapstatus = ldap.ldapstatus;
    static ldapsync = ldap.ldapsync;

    static fetchSessionTableRows = sessionTable.fetchSessionTableRows;
    static fetchScreencastTextTimeline = sessionTable.fetchScreencastTextTimeline;
}
